import React from 'react';



function Footer() {

  return(
    <div className='footer'>
      
      <footer>© PowerAsana 2022. All rights reserved.</footer>
     
    </div>
  )
}

export default Footer;